import { HttpApiService } from "@/shared/services/httpApi.service";

import { ACCESS_ENDPOINTS } from "../constants/accessCatalog.constants";
import type { CreateInvitationRequest, InvitationResponse } from "../types/access.types";

/**
 * Organization invitations (`/internal/invitations`) — the "invite a person" flow. The backend scopes every
 * call to the caller's organization (an inviter without one gets a 403) and gates create with `users:write`.
 * On create it emails the invitee a single-use accept link; a pending invite for the same email in the same
 * org is soft-revoked and replaced, while an email already registered — or pending in another org — is a
 * 409.
 */
export const invitationsService = {
  /** `POST /internal/invitations` — throttled server-side (5/min). */
  create: async (body: CreateInvitationRequest): Promise<InvitationResponse> => {
    const response = await HttpApiService.post<InvitationResponse, CreateInvitationRequest>(
      ACCESS_ENDPOINTS.INVITATIONS,
      body,
    );
    return response.data;
  },
};
